import {
  configureProductDucks,
  CARD_PRODUCT,
  PERSONAL_SAVINGS_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  PERSONAL_CHECKING_ACCOUNT,
  KABBAGE_ACCOUNT,
  KABBAGE_BCA,
  KABBAGE_INSIGHTS,
  KABBAGE_LOC,
  KABBAGE_PAYMENTS,
  CROSS_BORDER_PAYMENTS,
} from 'axp-product-ducks';

const productTypes = [
  CARD_PRODUCT,
  PERSONAL_SAVINGS_ACCOUNT,
  BUSINESS_CHECKING_ACCOUNT,
  PERSONAL_CHECKING_ACCOUNT,
  KABBAGE_ACCOUNT,
  KABBAGE_BCA,
  KABBAGE_INSIGHTS,
  KABBAGE_LOC,
  KABBAGE_PAYMENTS,
  CROSS_BORDER_PAYMENTS,
];

const configureProducts = () => {
  configureProductDucks({
    getToState: (state) => state.getIn(['modules', 'banking-root', 'products']),
    defaultTypes: [
      CARD_PRODUCT,
      PERSONAL_SAVINGS_ACCOUNT,
      BUSINESS_CHECKING_ACCOUNT,
    ],
    filterTypes: productTypes,
    orderTypes: productTypes,
    onAfterSelectProduct:
      ({ productId }) =>
      () => {
        if (global.BROWSER) {
          // save to allow preservation of the last selected product on refresh
          try {
            sessionStorage.setItem('activeProduct', productId);
          } catch {
            // session storage is not available, may be out of room or in a private window
            // on an old safari version
          }
        }
      },
  });
};

export default configureProducts;
